// extracted by mini-css-extract-plugin
module.exports = {"listNotifications":"ListNotifications_listNotifications__fUGUi","text":"ListNotifications_text__OQyjP"};